export type ShareOutcome = 'shared' | 'downloaded' | 'cancelled';

/** Save the file through a link click: what a browser that cannot share files gets. */
export function downloadFile(file: File) {
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.name;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Hand a picture or a video to the OS share sheet, and download it where that
 * cannot take files (a desktop browser) or refuses to (`NotAllowedError`, e.g.
 * a share no longer inside the tap that asked for it). A sheet the person
 * dismissed is `cancelled`, not a failure; any other error is thrown.
 */
export async function shareOrDownloadFile(file: File, { title, text }: { title?: string; text?: string } = {}): Promise<ShareOutcome> {
  if (!navigator.canShare?.({ files: [file] })) {
    downloadFile(file);
    return 'downloaded';
  }
  try {
    await navigator.share({ files: [file], title, text });
    return 'shared';
  } catch (err) {
    const name = (err as Error).name;
    if (name === 'AbortError') return 'cancelled';
    if (name === 'NotAllowedError') {
      downloadFile(file);
      return 'downloaded';
    }
    throw err;
  }
}
